import {SkosRepository, SkosScheme} from './SkosActions'

//Описание SKOS элементов
const initialSkosSchemesState = {
    state: "empty",         //Состояние загрузки элементов SKOS
    rfilter: [],            //Обязательный фильтр, который накладывается для отбора элементов
    conditions: [],         //Массив условий отбора
    offset: 0,
    limit: 10,
    count: -1,              //Всего количество элементов. -1 данные по количеству не загружены.
    head: {"link": [], "vars": ["IRI", "dsn", "dsv"]},
    distinct: false,
    ordered: true,
    scheme: {},             //Информация о схеме (skos:ConceptScheme)
    concept: {},            //Информация о концепте (skos:Concept)
    schemes: [],
    stack: null,            //Стек значений skos
    //Список URI графов, в которых хранятся данные. Массив значений {iri: '', state: ''}. 
    //Возможные состояния recommended, present, none, error    
    graphs: [],             
};

export const schemes = (state = { ...initialSkosSchemesState} , action) => {
    switch (action.type) {
        case "SkosRepository.EMPTY": 
            return{
                ...initialSkosSchemesState,
                state: "empty"
            }
        case "SkosRepository.LOAD_STARTED": 
            return{
                ...state,
                state: "load"
            }
        case "SkosRepository.LOAD_ERROR": 
            return {
                ...state,
                state: "error",
                error: action.error
            };            
        case "SkosRepository.LOAD_SCHEME_DETAILS":
            return {
                ...state,
                scheme: {
                    iri: action.iri,
                    values: action.values,
                    head: action.head, 
                    predicates: action.predicates, 
                    languages: action.languages,
                },
                state: "loaded"
            };
        case "SkosRepository.LOAD_SCHEMES": 
            return {
                ...state,
                offset: action.offset, 
                limit: action.limit, 
                count: action.count, 
                head: action.head, 
                distinct: action.distinct, 
                ordered: action.ordered, 
                schemes: action.schemes,
                state: "loaded",
            };
        case "SkosRepository.LOAD_NEXTSCHEMES": 
            return {
                ...state,
                offset: action.offset, 
                limit: action.limit, 
                head: action.head, 
                distinct: action.distinct, 
                ordered: action.ordered, 
                schemes: [...state.schemes, ...action.schemes],
                state: "loaded",
            };
        case "SkosRepository.USED_IN_CATALOG":
            const uschemes = [...state.schemes];
            for (let i=0; i<uschemes.length; i++) {
                if (uschemes[i].IRI.value == action.scheme){
                    uschemes[i]["catalog"] = {
                        state: (Array.isArray(action.values))? action.values.length>0? "loaded": "empty": "error",
                        items: (action.values)?  action.values: []
                    };
                }
            };
            return {
                ...state,
                schemes: uschemes
            };
        case "SkosRepository.ADD_SCHEME":
            const added = (state.schemes && Array.isArray(state.schemes))?[...state.schemes]: [];
            added.push({IRI: {type: "uri", value: action.iri},
                    dsn: {type: "literal", value: action.label}
            })
            return {
                ...state,
                schemes: added,
                state: "added"
            };
        case "SkosRepository.REMOVE_SCHEME":
            const r = (state.schemes && Array.isArray(state.schemes))?[...state.schemes]: [];
            return {
                ...state,
                schemes: r.filter(scheme => scheme.IRI.value!=action.iri),
                state: "remove"
            };            
        case "SkosRepository.CONDITIONS":
            return{
                ...state,
                schemes: [],
                offset: 0,
                conditions: action.conditions,
                state: "empty"
            }

        case "SkosRepository.LOAD_DESCRIPTION":
            const nadesc = (state.schemes)?[...state.schemes]: [];
            for (let i=0; i<nadesc.length; i++) {
                const nadesc_a = nadesc[i];
                if ((nadesc_a.IRI) && (nadesc_a.IRI.value==action.IRI)){
                    nadesc_a.description = action.description;
                    //Если в отбор попадают с IRI дубликатами, то повторно вызывается загрузка описания
                    //break;
                }
            }
            return{
                ...state,
                schemes: nadesc,
            }
        case "SkosRepository.PUSH":
            return {
                ...state,
                stack : {...state}
            }            
        case "SkosRepository.POP":
            const pop = (state.stack)? state.stack: state;
            return {
                ...pop,
            }            
        default:
            return state;
    }
};

//Дефаултные значения для конкретной схемы
const initialSkosSchemeState = {
    state: "empty",     //Состояние схемы
    iri: null,
    head: {             //Заголовок полученных данных. См. результаты запроса в request.js для values_sparql
        link:[],        //Неполнятно зачем возвращается TODO выяснить в документации.
        vars:[]         //Переменные, которые определены в данных (по их названию пожно получить занчение)
    },
    predicates: [],     //Список загруженных предикатов
    languages:  [],     //Список доступных языков (языки для которых есть данные)
    values: [],
    details:{},         //Элементы с детальной информацией . Содержит объект с ключём URI, содержащий данные по объекту
    taxonomy: null,         //Массив элементов вида {IRI: {type: "uri", value: "http://csi.semanticpro.org/authority/asset-category"}}
                            //После загруженного содержимого появится элемент concepts c концептами, schema данными схемы и state - состояние
    statistics:{},      //Статистика по концептам
};
export const scheme = (state = { ...initialSkosSchemeState}, action) => {
    switch (action.type) {
        case "SkosScheme.EMPTY":
            return{
                ...initialSkosSchemeState,
            }
        case "SkosScheme.LOAD_STARTED":
            return{
                ...state,
                state: "load",
            }
        case "SkosScheme.LOAD_ERROR":
            return {
                ...initialSkosSchemeState,
                state: "error",
                error: action.error
            };
        case "SkosScheme.LOAD_SCHEME":
            return {
                ...state,
                iri: action.iri,
                types: action.types,
                values: action.values,
                head: action.head, 
                predicates: action.predicates, 
                languages: action.languages,
                concepts: action.concepts,
                graphs: action.graphs,
                state: "loaded",
            };

        case "SkosScheme.LOAD_TAXONOMY":
            const n = (state.taxonomy)?[...state.taxonomy]: [];
            let isExist = false; //Нужно, если элемент отсутствовал
            for (let i=0; i<n.length; i++) {
                if (isExist) break;
                const schema = n[i];
                //Каждый элемент {IRI: {type: "uri", value: "http://csi.semanticpro.org/authority/asset-category"}
                //Label: {type: "literal", xml:lang: "ru", value: "Категория семантического актива"}}
                if ((schema.IRI) && (schema.IRI.value==action.taxonomy)){
                    schema.concepts = action.concepts,
                    schema.schema = action.schema;
                    schema.broader = action.broader;
                    schema.identifier = action.identifier;
                    schema.state="loaded";
                    isExist = true;
                }
            }
            if (!isExist){
                const t = {
                    IRI: {type: "uri", value: action.taxonomy}, 
                    concepts: action.concepts, 
                    schema: action.schema, 
                    broader: action.broader,
                    identifier: action.identifier,
                    state: "loaded",
                    context: "TAXONOMY"
                };
                n.push(t);
            }
            return {
                ...state,
                state: "loaded",
                taxonomy: n,
                concepts: [...new Set(action.concepts.map(item => item.IRI.value))]
            };

        case "SkosScheme.STATISTICS":
            const {statistics} = state;
            const s = (statistics)?statistics:{};
            s[action.IRI] = (typeof s[action.IRI] ==='undefined')? action.statistic: Object.assign({}, s[action.IRI], action.statistic);
            return {
                ...state,
                statistics: s,
            };

        case "SkosScheme.LOAD_LABELBYIRI":
            const lbi = (state.values && Array.isArray(state.values))?[...state.values]:[];
            for (let i=0; i<lbi.length; i++) {
                if (lbi[i].object.value == action.iri)
                    lbi[i].labels = {head: action.head, values: action.values};
            }
            return {
            ...state,
            values: lbi,
        };
        case "SkosScheme.LOAD_CONCEPTS":
            return {
                ...state,
                concepts: action.concepts
            };

        case "SkosScheme.RELOAD_CONCEPT": 
            const rld = (Array.isArray(state.concepts))? [...state.concepts]:[];
            const rvd = (Array.isArray(state.values))?[...state.values]:[];
            for (let i=0; i<rld.length; i++) {
                if (rld[i].object.value == action.iri)
                rld[i].values = action.values;
            };
            for (let i=0; i<rvd.length; i++) {
                if (rvd[i].object.value == action.iri)
                    rvd.values = action.values;
            };
            return {
                ...state,
                values: rvd,
                concepts: rld
            };     
        case "SkosScheme.LOAD_DETAIL":
            const ld = (state.values && Array.isArray(state.values))?[...state.values]:[];
            const {predicat, object } = action.triplet;
            for (let i=0; i<ld.length; i++) {
                if ((ld[i].object.value == object.value) && (ld[i].predicat.value == predicat.value)){
                    ld[i].values = action.values;
                    ld[i].state = action.state;
                    ld[i].head = action.head;
                }
            }
            const {details} = state;
            details[object.value] = {
                values: action.values, 
                state: action.state, 
                head: action.head, 
                predicates: action.predicates,
                languages: action.languages
            };    
            return {
                ...state,
                values: ld,
                details
            };

        case "SkosScheme.LOAD_CONCEPT":
            const lc_detail = state.details;
            lc_detail[action.concept] = {
                values: action.values, 
                state: action.state, 
                head: action.head, 
                predicates: action.predicates,
                languages: action.languages};
            return {
                ...state,
                details: lc_detail
            };
            
        case "SkosScheme.REMOVE_CONCEPT":
            const rd = (state.concepts && Array.isArray(state.concepts))?[...state.concepts]: [];
            return {
                ...state,
                values: state.values.filter(value => value.object.value != action.iri),
                concepts: rd.filter(concept => concept.object.value!=action.iri)
            };                        

        case "SkosScheme.ADD_CONCEPT":
            const ad = (state.concepts && Array.isArray(state.concepts))?[...state.concepts]: [];
            ad[ad.length] = {predicat: {type: "uri", value: "https://www.w3.org/2009/08/skos-reference/skos.html#Concept"}, object: {type: "uri", value: action.iri}}
            return {
                ...state,
                concepts: ad
            };                                
            
        case "SkosScheme.GRAPH_STATE":
            const graphs = (state.graphs && Array.isArray(state.graphs))?[...state.graphs]:[];
            const hasGraph = graphs.filter(graph => graph.iri == action.iri).length>0; 
            if (hasGraph)
                for (let i=0; i<graphs.length; i++) {
                    if (graphs[i].iri == action.iri){
                        graphs[i].state = action.state;
                        break;
                    }
                }
            else 
                graphs.push({iri:action.iri, state: action.state});
            return {
                ...state,
                graphs
            }                         
    default:
            return state;
    }
}
